import './index.scss'
import Sidebar from '../Sidebar';


const About = () => {
    return(
        <>
        <Sidebar />
        <div className='container about-page'>
            <div className="text-zone">
            <div class="header">
                <h1>About me</h1>
            </div>
            <div class="zone"> 
                <p class="paragraph">Hello! I am Sulagna, an international student from Bangladesh enjoying Computer Science in her undergrad.</p>
                    <div class="paragraph">
                        <em><strong>Here's the things I am proud to do last semester :) </strong></em>
                        <ol>
                            <li>Staying far from home for a year</li>
                            <li>Handling a 5-course academic load</li>
                            <li>Taking a class at Smith College -a five college course</li>
                            <li>Participating in PUTNAM</li>
                            <li>Starting driving lesson</li>
                            <li>Leading a workshop at Girls Who Code as an Event Coordinator</li>
                            <li>Participated in a Hackathon in Boston and won a prize</li>
                            <li>Learned the song “Different World” on Piano</li>
                        </ol>
                    </div>
                    <div class="paragraph">
                        <em><strong>Here's the things I look forward to this semester! </strong></em>
                        <ol>
                            <li>Taking a course at Amherst College!(This course)</li>
                            <li>Being a Resident Advisor</li>
                            <li>Working on a independent project</li>
                            <li>Taking a music class!</li>
                            <li>Making a small fire-fighter robot!</li>
                            <li>Getting better as a coder</li>
                            <li>Being a TA for a class harder to handle</li>
                        </ol>
                    </div>
                </div>  
            </div>
        </div>
        </>
    )
}

export default About